import React from 'react';
import s from './s.module.less';
import { CheckOutlined } from '@ant-design/icons';

const Step1 = () => {
    const steps = [
        {
            id: 1,
            title: 'Create profile',
            status: 'completed',
        },
        {
            id: 2,
            title: 'Set up services',
            status: 'completed',
        },
        {
            id: 3,
            title: 'List on Klarity Health',
            status: 'current',
        },
        {
            id: 4,
            title: 'Configure availability',
            status: 'upcoming',
        },
    ];

    return (
        <div className={s.wrap}>
            <div className={s.content}>
                <div className={s.header}>
                    <h1>You're almost there!</h1>
                    <div className={s.headerDescription}>
                        Let's set up your payment method so you're ready to receive bookings. Please add your payment method, upload your government-issued and medical license. Once approved, your profile will go live for patients to book with you.
                    </div>
                </div>

                <div className={s.progressContainer}>
                    {steps.map((step, index) => (
                        <div key={step.id} className={s.stepWrapper}>
                            <div className={s.stepItem}>
                                <div className={`${s.stepIcon} ${s[step.status]}`}>
                                    {step.status === 'completed' ? (
                                        <CheckOutlined className={s.checkIcon} />
                                    ) : (
                                        <span className={s.stepNumber}>{step.id}</span>
                                    )}
                                </div>
                                <span className={`${s.stepTitle} ${s[step.status]}`}>
                                    {step.title}
                                </span>
                            </div>

                            {index < steps.length - 1 && (
                                <div className={`${s.connector} ${steps[index + 1].status === 'completed' ? s.completed : s.pending}`} />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Step1;
